<template>
  <div class="filter-pill-container">
    <v-select
      v-if="responsive"
      class="d-sm-none"
      :items="selectItems"
      :value="activeIndex"
      label="View dogs"
      outlined
      dense
      hide-details
      @change="toggle"
    />
    <v-slide-group
      v-if="responsive"
      class="hidden-xs-only"
      :value="activeIndex"
      center-active
      show-arrows
    >
      <v-slide-item
        v-for="(item, index) in pills"
        :key="index + '-pill'"
        :value="index"
      >
        <v-chip
          @click="toggle(index)"
          class="mr-3"
          v-bind:class="item.active ? 'active-pill' : 'filter-pill'"
          >{{ item.name }}
          <v-tooltip bottom v-if="item.tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="darkGray" class="ml-1" dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>{{item.tooltip}}</span>
          </v-tooltip></v-chip
        >
      </v-slide-item>
    </v-slide-group>
    <template v-if="!responsive">
      <v-chip
        v-for="(item, index) in pills"
        :key="index + '-pill'"
        @click="toggle(index)"
        class="mr-3"
        v-bind:class="item.active ? 'active-pill' : 'filter-pill'"
        >{{ item.name }}
        <v-tooltip bottom v-if="item.tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="darkGray" class="ml-1" dark v-bind="attrs" v-on="on">
              mdi-information
            </v-icon>
          </template>
          <span>{{item.tooltip}}</span>
        </v-tooltip></v-chip
      >
    </template>
  </div>
</template>

<script>
export default {
  name: "FilterPills",
  props: {
    pills: {
      type: Array,
      default: () => [{ name: "link", active: false }],
    },
    responsive: Boolean,
    toggle: { type: Function },
  },
  computed: {
    activeIndex() {
      return this.pills.findIndex((pill) => pill.active);
    },
    selectItems() {
      return this.pills.map((pill, index) => ({
        text: pill.name,
        value: index,
      }));
    },
  },
};
</script>
